module.exports = __webpack_public_path__ + "static/media/icon-detail-light-blue.04ed8771.svg";